import SubNavigation from "../../components/Header/SubNavigation";
import { Section } from "design-react-kit";
import Footer from "../../components/Footer";
import AuthModuleVerificationTable from "../../components/Tables/AuthModuleVerificationTable";
import { Fragment } from "react";

const AuthModuleFlowNotifications = () => {
  return (
    <Fragment>
      <SubNavigation page="authModuleNotifs" />
      <Section>
        <AuthModuleVerificationTable
          columns={[
            {
              name: "Data di acquisizione",
              type: "date",
              sortable: false,
              value: "createdOn",
            },
            {
              name: "Notifica",
              type: "string",
              sortable: true,
              value: "subject",
            },
            {
              name: "Codice fiscale destinatario",
              type: "string",
              sortable: false,
              value: "recipientFiscalCode",
            },
            {
              name: "Numero avviso pagoPA",
              type: "string",
              sortable: false,
              value: "paymentNoticeCode",
            },
            {
              name: "Importo notifica",
              type: "string",
              sortable: false,
              value: "amount",
            },
            {
              name: "",
              type: null,
              sortable: false,
              value: "",
            },
          ]}
        />
      </Section>
      <Footer />
    </Fragment>
  );
};

export default AuthModuleFlowNotifications;
